import { ReactNode } from "react"
import { Link, LinkProps } from "react-router-dom"
import { buttonClasses, ButtonSize, ButtonVariant } from "components/ui/buttonStyles"

export interface ButtonLinkProps extends Omit<LinkProps, "className"> {
  variant?: ButtonVariant
  size?: ButtonSize
  fullWidth?: boolean
  className?: string
  children: ReactNode
}

/**
 * A react-router `Link` styled identically to `Button`. Use for navigation
 * that should look like a button (CTAs, "Go to ..." actions).
 */
export const ButtonLink = ({
  variant = "primary",
  size = "md",
  fullWidth = false,
  className,
  children,
  ...props
}: ButtonLinkProps) => (
  <Link className={buttonClasses({ variant, size, fullWidth, className })} {...props}>
    {children}
  </Link>
)
